module.exports = __webpack_public_path__ + "static/media/scanner-staging.fe3adcbd.apk";